import React from 'react';
import {connect} from "react-redux";
import {withRouter} from 'react-router-dom';

import {CourseStates} from 'components/common/app';
import {
    Input,
    Button,
    IconButton,
    CardContainer,
    Loading,
    Notification,
    Validator,
    ConfirmDialog
} from 'components/common/uiKit';

import {serverUrl} from 'services/network';
import {CourseApi} from 'services/network/api';
import {convertDigitsToStandard} from 'services/converts/numbers';

import NoImage from 'assets/images/NoImage.jpg';


class Info extends React.Component {
    constructor(props) {
        super(props);


        this.state = {
            courseId: props.courseId,
            loading: true,
            btnLoading: false,
            uploadLoading: false,
            deleteConfirmDialog: false,
            deleteConfirmLoading: false,

            image: undefined,
            title: '',
            summary: '',
            price: 0,
            renewalPrice: 0,
            time: 0,
            description: '',
            courseState: 0
        };

        this.validator = Validator(props.locale.abbreviation);
    }

    componentDidMount() {
        const {courseId} = this.state;
        this.loadData(courseId);
    }

    async loadData(courseId) {
        if (courseId) {
            CourseApi.GetAdminDetails(courseId)
                .then(res => {
                    if (res && res.status == 200) {
                        const {data} = res;
                        const {image, title, summary, price, renewalPrice, time, description} = data;
                        const courseState = data.state;
                        this.setState({image, title, summary, price, renewalPrice, time, description, courseState});
                    }
                }).finally(() => {
                this.setState({loading: false});
            });
        }
    }

    handleImageUpload = (evt) => {
        const file = evt.target.files;
        if (file) {
            this.setState({uploadLoading: true});
            const {courseId} = this.state;

            let formData = new FormData();
            formData.append("CourseId", courseId);
            formData.append("File", file[0]);

            CourseApi.UploadImage(formData)
                .then(res => {
                    if (res && res.status) {
                        const {data} = res;
                        const {image} = data;
                        this.setState({image});
                        Notification('success', 'Succeed');
                    }
                }).finally(() => {
                this.setState({uploadLoading: false});
            });
        }
    };

    handleInputChange = name => event => {
        this.setState({[name]: convertDigitsToStandard(event.target.value)});
    };

    handleCourseStateChange = event => {
        const courseState = parseInt(event.target.value);
        this.setState({courseState});
    };

    handleSubmit = () => {
        this.setState({btnLoading: true});

        const formValidateResult = this.validator.allValid();
        if (formValidateResult) {
            const {courseId, title, summary, description, time, price, renewalPrice, courseState} = this.state;
            const model = {
                id: parseInt(courseId),
                title,
                summary,
                description,
                time: parseInt(time),
                price: parseInt(price),
                renewalPrice: parseInt(renewalPrice),
                state: courseState
            };
            CourseApi.Update(model)
                .then(res => {
                        if (res && res.status == 200) {
                            Notification('success', 'Succeed');
                            this.loadData();
                        }
                    }
                ).finally(() => {
                this.setState({btnLoading: false});
            });

        } else {
            this.validator.showMessages();
            this.forceUpdate();
            Notification('error', 'WrongData');
            this.setState({btnLoading: false});
        }
    };

    handleDeleteOnClick = () => {
        this.setState({deleteConfirmDialog: true});
    };

    handleConfirmDelete = () => {
        const {courseId} = this.state;
        if (courseId) {
            this.setState({deleteConfirmLoading: true});
            CourseApi.Delete(courseId)
                .then(res => {
                    if (res && res.status == 200) {
                        Notification('success', 'Succeed');

                        const {history} = this.props;
                        history.goBack();
                    }
                }).finally(() => {
                this.setState({deleteConfirmLoading: false, deleteConfirmDialog: false});
            });
        }
    };

    handleCancelDelete = () => {
        this.setState({deleteConfirmDialog: false});
    };

    render() {
        const {btnLoading, loading, uploadLoading, deleteConfirmDialog, deleteConfirmLoading} = this.state;

        if (loading) {
            return (
                <Loading/>
            );
        }

        const {locale} = this.props;
        const pageTranslates = locale.translation.Pages.Admin.CMS.Info;

        const {image, title, summary, price, renewalPrice, time, description, courseState} = this.state;

        const imageUrl = image ? `${serverUrl}${image.split('\\').join('/')}` : NoImage;

        return (
            <>
                <CardContainer disablePadding>
                    <div style={{position: 'relative'}}>
                        <img src={imageUrl} className="preload-img img-fluid bottom-20 w-100"/>

                        <div onClick={() => global.document.getElementById('browseImageFileButton').click()}>
                            <input
                                id="browseImageFileButton"
                                type="file"
                                accept="image/*"
                                onChange={this.handleImageUpload}
                                hidden
                            />
                            <IconButton icon='pen' color='primary' loading={uploadLoading} style={{
                                position: 'absolute',
                                fontSize: 18,
                                left: 15,
                                bottom: 15,
                                backgroundColor: '#eee'
                            }}/>

                        </div>
                    </div>

                    <div style={{padding: 7}}>
                        <div className='mt-2'>
                            <Input placeholder={pageTranslates.Title} value={title} label={pageTranslates.Title}
                                   onChange={this.handleInputChange('title')}/>
                            {this.validator.message(pageTranslates.Title, title, 'required|min:3')}
                        </div>

                        <div className='mt-2'>
                            <Input placeholder={pageTranslates.Summary} value={summary} label={pageTranslates.Summary}
                                   onChange={this.handleInputChange('summary')}/>
                            {this.validator.message(pageTranslates.Summary, summary, 'required|max:100')}
                        </div>

                        <div className='mt-2'>
                            <Input placeholder={pageTranslates.Price} type='tel' value={price}
                                   label={pageTranslates.Price}
                                   onChange={this.handleInputChange('price')}/>
                            {price ?
                                <small className='font-10'>
                                    {parseInt(price).toLocaleString()} {pageTranslates.Currency}
                                </small>
                                : ''
                            }
                            {this.validator.message(pageTranslates.Price, price, 'required|integer|regex:^[1-9]\\d*$')}
                        </div>

                        <div className='mt-2'>
                            <Input placeholder={pageTranslates.RenewalPrice} type='tel' value={renewalPrice}
                                   label={pageTranslates.RenewalPrice}
                                   onChange={this.handleInputChange('renewalPrice')}/>
                            {renewalPrice ?
                                <small className='font-10'>
                                    {parseInt(renewalPrice).toLocaleString()} {pageTranslates.Currency}
                                </small>
                                : ''
                            }
                            {this.validator.message(pageTranslates.RenewalPrice, renewalPrice, 'required|integer|regex:^[1-9]\\d*$')}
                        </div>

                        <div className='mt-2'>
                            <Input placeholder={pageTranslates.ExpireDate} type='tel' value={time}
                                   label={pageTranslates.ExpireDate}
                                   onChange={this.handleInputChange('time')}/>
                            {this.validator.message(pageTranslates.ExpireDate, time, 'required|integer|regex:^[1-9]\\d*$')}
                        </div>

                        <div className='mt-2'>
                            <label className='color-primary font-12'>
                                {pageTranslates.State}
                            </label>
                            <CourseStates value={courseState} onChange={this.handleCourseStateChange}/>
                        </div>

                        <div className='mt-2'>
                            <Input placeholder={pageTranslates.Description} value={description}
                                   label={pageTranslates.Description} type='text-area'
                                   onChange={this.handleInputChange('description')}/>
                            {this.validator.message(pageTranslates.Description, description, 'required')}
                        </div>

                        <Button type='primary' full loading={btnLoading} onClick={this.handleSubmit}>
                            {pageTranslates.Submit}
                        </Button>
                        <Button type='danger' full loading={btnLoading} onClick={this.handleDeleteOnClick}>
                            {pageTranslates.Delete}
                        </Button>
                    </div>
                </CardContainer>

                <ConfirmDialog open={deleteConfirmDialog} title={pageTranslates.DeleteConfirmDialog.Title}
                               content={pageTranslates.DeleteConfirmDialog.Content}
                               onAgree={this.handleConfirmDelete} onCancel={this.handleCancelDelete}
                               agreeLoading={deleteConfirmLoading}/>
            </>
        );
    }
}

const mapStateToProps = state => {
    const {locale} = state;
    return {locale};
};

export default connect(mapStateToProps, null)(withRouter(Info));
